import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Modal,
  Skeleton,
  InputAdornment,
  Tooltip,
  FormControl,
  InputLabel,
} from "@mui/material";
import { headingStyle, tableRowLab } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { primaryBtn } from "../../style/AppointmentStyle";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { showToast } from "../../utils/toastUtil";
import { autoFocusOffWithOutBorder } from "../../style/PatinetFormStyle";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import json_icon from "../../assets/json_icon.svg";
import csv_icon from "../../assets/csv_icon.svg";
import CustomModal from "../CustomModal/CustomModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NewMedicineSalt from "./NewMedicineSalt";
import medicine_salt from "../../assets/medicine_salt.svg";
import MedicineSaltDetails from "./MedicineSaltDetails";
import EditMedicineSalt from "./EditMedicineSalt";
import UseFetchMedicineSaltList from "../../helper/UseFetchMedicineSaltList";
import {
  formattedDateWithoutBg,
  handleDownloadCsvMedicine,
  handleShowJson,
} from "../../utils/constantFunctions";
import { deleteMedicineSalt } from "../../connections/deleteApi";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useNavigate } from "react-router-dom";
import useDebounce from "../../hooks/UseDebounce";

const MedicineSalt = ({ onClose }) => {
  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [editPurchaseOrderModal, setEditPurchaseOrderModal] = useState(false);
  const [newMedicineSaltModal, setNewMedicineOrderModal] = useState(false);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [id, setId] = useState(null);

  const [medicineSearchInput, setMedicineSearchInput] = useState(null);

  //  console.log(medicineList?.payload?.medicines);
  const handleMedicineChange = (e) => {
    e.preventDefault();
    setMedicineSearchInput(e?.target?.value);
  };

  const debouncedInputMedicine = useDebounce(medicineSearchInput, 1000);

  // const { data: medicineList, refetch, isLoading } = UseFetchMedicineAdmin(page, itemPerPage, debouncedInputMedicine);

  const {
    data: medicineSaltList,
    refetch,
    isLoading,
  } = UseFetchMedicineSaltList(page, itemPerPage, debouncedInputMedicine);
  const navigate = useNavigate();

  const totalRecords = medicineSaltList?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  // useEffect(() => {
  //   refetch(page, itemPerPage)
  // }, [page, itemPerPage]);

  const handleDelete = async (id) => {
    setDeleteModal(false);
    const res = await deleteMedicineSalt(id);
    //  console.log(res);

    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status) {
      refetch(page, itemPerPage);
    }
  };


  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* //modals for delete and filter */}

        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          sx={{
            position: "absolute",
            top: "25%",
            // left:'50%',
            width: "450px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: 3.6,
              boxShadow: 24,
              p: 4.5,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography textAlign={"center"}>Are you sure?</Typography>
              <Typography textAlign={"center"}>
                You want to delete these selected purchase orders?
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "flex",
                gap: "25px",
                width: "max-content",
                margin: "auto",
                marginTop: "40px",
              }}
            >
              <Button
                onClick={() => handleDelete(id)}
                sx={{
                  backgroundColor: "#FF392B",
                  color: "white",
                  border: "",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "red",
                  },
                }}
              >
                Delete
              </Button>

              <Button
                onClick={() => setDeleteModal(false)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  border: "2px solid #FF392B",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={filterModal}
          onClose={() => setFilterModal(false)}
          sx={{
            position: "absolute",
            top: "14%",
            // left:'50%',
            width: "340px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: "20px",
              boxShadow: 24,
              p: 1,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Grid container spacing={2} sx={{ padding: "9px" }}>
              <Grid item xs={12}>
                <Typography
                  variant="subTitle116px"
                  fontWeight={"600"}
                  textAlign={"center"}
                  margin={"auto"}
                >
                  Filters
                </Typography>
              </Grid>

              {/* <Grid item xs={12}>
        <Typography  variant="subTitle116px" >Suppliers</Typography>
      </Grid> */}

              {/* Filter Selection */}
              <Grid item xs={12}>
                <Select
                  fullWidth
                  defaultValue=""
                  placeholder="Select Filter"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "neutral.blueShadeBg",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "text.default_grey" }}>
                          Select filter
                        </span>
                      );
                    }
                    return selected === "filter1"
                      ? "filter2"
                      : selected === "filter3"
                        ? "filter3"
                        : "select filter";
                  }}
                >
                  <MenuItem value="filter1">Filter 1</MenuItem>
                  <MenuItem value="filter2">Filter 2</MenuItem>
                  <MenuItem value="filter3">Filter 3</MenuItem>
                </Select>
              </Grid>

              {/* Purchase Date */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Purchase Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Department Selection */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Department</Typography>
                <Select
                  fullWidth
                  defaultValue=""
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "neutral.blueShadeBg",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <MenuItem value="dept1">Department 1</MenuItem>
                  <MenuItem value="dept2">Department 2</MenuItem>
                  <MenuItem value="dept3">Department 3</MenuItem>
                </Select>
              </Grid>

              {/* Created At */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Created At</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Buttons */}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtnTeal, color: "white" }}
                >
                  Apply
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => setFilterModal(false)}
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtn, color: "white", border: "none" }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            mb={1}
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={medicine_salt}
                alt=""
                style={{ width: "28px", height: "28px", display: "block" }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                sx={{ ...headingStyle, mb: 0 }}
              >
                Medicine salts
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "1rem" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            mt={-1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            // paddingX="14px"
            ml={0.5}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: "12px", alignItems: "center" }}>
              <AddRoundedIcon
                onClick={() => setNewMedicineOrderModal(true)}
                sx={{
                  backgroundColor: "#FFE7DC",
                  p: "4px",
                  width: "24px",
                  height: "24px",
                  color: "#FF8D1E",
                  borderRadius: "8px",
                  cursor: "pointer",
                  flexShrink: 0,
                }}
              />
              <TextField
                sx={{ ...autoFocusOffWithOutBorder }}
                type="text"
                className="form-control"
                placeholder="Search Medicine Salt"
                value={medicineSearchInput}
                onChange={handleMedicineChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {/* <Box > <AddRoundedIcon onClick={()=>setNewMedicineOrderModal(true)} sx={{backgroundColor:"#FFE7DC" ,p:'4px',  width:"20px", color:"#FF8D1E" , borderRadius:"8px" ,cursor:"pointer"}}   /></Box> */}

            <Box
              onClick={() => setFilterModal(true)}
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: "20px",
              }}
            >
              {/* <IconButton  >
          <TuneRoundedIcon size="small"  sx={{color:"#0067FF"}}/>  
        </IconButton>
        <Typography>
         Filters
        </Typography>  */}
            </Box>
          </Box>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%", maxHeight: "60vh", overflowY: "auto" }}>
              <Table sx={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 6px" }} stickyHeader>
                <TableHead>
                  <TableRow
                    sx={{
                      textAlign: "center",
                      // "& th": { backgroundColor: "#EDEDED" },
                    }}
                  >
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                        borderTopLeftRadius: "16px",
                        borderBottomLeftRadius: "16px",
                      }}
                    >
                      ID
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{ color: "neutral.black", p: "8px", textAlign: "left" }}
                    >
                      Medicine salt names
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{ color: "neutral.black", p: "8px", textAlign: "center" }}
                    >
                      Created at
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{ color: "neutral.black", p: "8px", textAlign: "center" }}
                    >
                      Updated at
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                        borderTopRightRadius: "16px",
                        borderBottomRightRadius: "16px",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                  {/* gap between header and body */}
                  <TableRow sx={{ height: "8px", "& td, & th": { padding: 0, border: 0, backgroundColor: "transparent" } }}>
                    <TableCell colSpan={5} />
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} sx={{ p: 0 }}>
                        <Box
                          sx={{
                            rowGap: 1.2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  medicineSaltList?.payload?.medicine_salts?.length > 0 && (
                    <TableBody>
                      {medicineSaltList.payload?.medicine_salts?.map(
                        (item, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              width: "100%",
                              ...tableRowLab,
                              p:0,
                              textAlign: "center",
                              backgroundColor: "neutral.blueShadeBg",
                           
                            }}
                          >
                            {/* 
        <TableCell
          sx={{
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
            color: "neutral.black",
            p: "8px",
            textAlign: "center",
          }}
        >
          <Checkbox />
        </TableCell> */}

                            <TableCell
                              sx={{
                                borderTopLeftRadius: "20px",
                                borderBottomLeftRadius: "20px",
                                color: "neutral.black",
                                p: "8px",
                                textAlign: "center",
                              }}
                            >
                              <Typography
                                variant="subTitle116px"
                                sx={{ color: "#3A3A3A" }}
                              >
                                {item?.id}
                              </Typography>
                            </TableCell>

                            <TableCell
                              //  width={'40%'}
                              sx={{
                                color: "neutral.black",
                                p: "8px",
                              }}
                            >
                              <Tooltip
                                title={item?.name}
                                arrow
                                onClick={() => {
                                  setDetailsModal(true);
                                  setId(item?.id);
                                }}
                              >
                                <Typography
                                  variant="subTitle116px"
                                  sx={{
                                    color: "#0067FF",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: 600, // set max width as needed
                                    cursor: "pointer",
                                    display: "inline-block",
                                  }}
                                >
                                  {item?.name}
                                </Typography>
                              </Tooltip>
                            </TableCell>

                            <TableCell
                              sx={{
                                paddingRight: "30px",
                                color: "neutral.black",
                                p: "8px",
                                textAlign: "center",
                              }}
                            >
                              <Tooltip
                                title={`Create time - ${item.created_at.split(" ")[1]}`}
                                arrow
                              >
                                <Typography
                                  variant="subTitle116px"
                                  fontSize="14px"
                                  sx={{
                                    color: "#3A3A3A",
                                    cursor: "pointer", // optional, to indicate hover
                                  }}
                                >
                                  <Typography
                                    variant="subTitle116px"
                                    fontSize={"14px"}
                                    fontWeight={"400"}
                                    sx={{ color: "#3A3A3A" }}
                                  >
                                    {" "}
                                    {formattedDateWithoutBg(
                                      item.created_at.split(" ")[0],
                                    )}
                                  </Typography>
                                </Typography>
                              </Tooltip>
                            </TableCell>

                            <TableCell
                              sx={{
                                color: "neutral.black",
                                p: "8px",
                                textAlign: "center",
                              }}
                            >
                              <Tooltip
                                title={`Update time - ${item.updated_at.split(" ")[1]}`}
                                arrow
                              >
                                <Typography
                                  variant="subTitle116px"
                                  fontSize="14px"
                                  sx={{
                                    color: "#3A3A3A",
                                    cursor: "pointer", // optional, to indicate hover
                                  }}
                                >
                                  <Typography
                                    variant="subTitle116px"
                                    fontSize={"14px"}
                                    fontWeight={"400"}
                                    sx={{ color: "#3A3A3A" }}
                                  >
                                    {" "}
                                    {formattedDateWithoutBg(
                                      item.updated_at.split(" ")[0],
                                    )}
                                  </Typography>
                                </Typography>
                              </Tooltip>
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                borderTopRightRadius: "20px",
                                borderBottomRightRadius: "20px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "8px",
                                  margin: "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <RemoveRedEyeOutlinedIcon
                                  onClick={() => {
                                    setDetailsModal(true);
                                    setId(item?.id);
                                  }}
                                  sx={{
                                    backgroundColor: "#0067FF",
                                    p: "4px",
                                    width: "18px",
                                    color: "white",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                />
                                <EditOutlinedIcon
                                  onClick={() => {
                                    setEditPurchaseOrderModal(true);
                                    navigate("/pharmacy", { state: item });
                                  }}
                                  sx={{
                                    backgroundColor: "#FF8D1E",
                                    p: "4px",
                                    width: "18px",
                                    color: "white",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                />
                                <DeleteForeverOutlinedIcon
                                  onClick={() => {
                                    setDeleteModal(true);
                                    setId(item?.id);
                                  }}
                                  sx={{
                                    backgroundColor: "#FF392B",
                                    p: "4px",
                                    width: "18px",
                                    color: "white",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                        ),
                      )}
                    </TableBody>
                  )
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          container
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ zIndex: "10" }}
          lg={12}
          marginBottom={"5px"}
          paddingX={"20px"}
        >
          <Grid item>
            <Box sx={{ display: "flex", gap: "8px" }}>
              <Box
                sx={{ cursor: "pointer" }}
                onClick={() =>
                  handleDownloadCsvMedicine(
                    medicineSaltList?.payload?.medicine_salts,
                  )
                }
              >
                <img
                  src={csv_icon}
                  alt=""
                  width={"28px"}
                  sx={{ cursor: "pointer" }}
                />{" "}
              </Box>

              <Box
                sx={{ cursor: "pointer" }}
                onClick={() =>
                  handleShowJson(medicineSaltList?.payload?.medicine_salts)
                }
              >
                {" "}
                <img src={json_icon} alt="" sx={{ cursor: "pointer" }} />{" "}
              </Box>

              {/* <img src={} alt=""/> */}
            </Box>
          </Grid>

          <Grid item sx={{ display: "flex", alignItems: "center" }}>
            <Box gap={1} display="flex" alignItems="center" flexWrap="wrap">
              {/* Previous */}
              <Button
                onClick={handlePrevious}
                disabled={page === 1}
                startIcon={<ArrowBackIcon sx={{ fontSize: "14px !important" }} />}
                sx={{ fontSize: "12px", textTransform: "capitalize", color: page === 1 ? "grey" : "#336cfb", minWidth: "auto" }}
              >
                Prev
              </Button>

              {/* Page numbers with ellipsis */}
              {(() => {
                const pages = [];
                if (totalPage <= 7) {
                  for (let i = 1; i <= totalPage; i++) pages.push(i);
                } else {
                  pages.push(1);
                  if (page > 3) pages.push("...");
                  for (let i = Math.max(2, page - 1); i <= Math.min(totalPage - 1, page + 1); i++) pages.push(i);
                  if (page < totalPage - 2) pages.push("...");
                  pages.push(totalPage);
                }
                return pages.map((p, i) =>
                  p === "..." ? (
                    <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", color: "#888", px: "2px", alignSelf: "center" }}>…</Typography>
                  ) : (
                    <Button
                      key={p}
                      onClick={() => setPage(p)}
                      sx={{
                        fontSize: "12px",
                        minWidth: "30px",
                        height: "30px",
                        padding: "2px",
                        borderRadius: "6px",
                        color: page === p ? "#fff" : "#333",
                        backgroundColor: page === p ? "#007A99" : "#fff",
                        border: "1px solid #d0d0d0",
                        "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                      }}
                    >
                      {p}
                    </Button>
                  )
                );
              })()}

              {/* Next */}
              <Button
                onClick={handleNext}
                disabled={page === totalPage}
                endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
                sx={{ fontSize: "12px", textTransform: "capitalize", color: page === totalPage ? "grey" : "#336cfb", minWidth: "auto" }}
              >
                Next
              </Button>

              {/* Jump to page */}
              <Box display="flex" alignItems="center" gap="4px" ml={1}>
                <Typography sx={{ fontSize: "12px", color: "#555", whiteSpace: "nowrap" }}>Go to</Typography>
                <TextField
                  size="small"
                  type="number"
                  inputProps={{ min: 1, max: totalPage, style: { padding: "2px 6px", fontSize: "12px", width: "44px", textAlign: "center" } }}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", height: "30px" } }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const val = parseInt(e.target.value, 10);
                      if (val >= 1 && val <= totalPage) { setPage(val); e.target.value = ""; }
                    }
                  }}
                />
              </Box>

              {/* Rows per page */}
              <FormControl size="small" sx={{ ml: 1, minWidth: "80px" }}>
                <InputLabel>Rows</InputLabel>
                <Select
                  value={itemPerPage}
                  label="Rows"
                  onChange={(e) => { setItemPerPage(e.target.value); setPage(1); }}
                  sx={{ height: "30px", fontSize: "12px", borderRadius: "6px" }}
                >
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Box>
      </Box>
      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "89%" }}
        open={detailsModal}
        setDetailsModal
        onClose={() => setDetailsModal(false)}
      >
        <MedicineSaltDetails
          onClose={() => setDetailsModal(false)}
          id={id}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={editPurchaseOrderModal}
        onClose={() => setEditPurchaseOrderModal(false)}
      >
        <EditMedicineSalt
          onClose={() => setEditPurchaseOrderModal(false)}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "85%" }}
        open={newMedicineSaltModal}
        onClose={() => setNewMedicineOrderModal(false)}
      >
        <NewMedicineSalt
          onClose={() => setNewMedicineOrderModal(false)}
          refetch={refetch}
        />
      </CustomModal>
    </>
  );
};

export default MedicineSalt;
